import React, { useState } from "react";
import CreateApiKey from "./createApiKey";
import ContentHeader from "../../../reusableComponents/contentHeader/ContentHeader";
import PowerOutlinedIcon from "@mui/icons-material/PowerOutlined";
import { colorBrandObject } from "../../../../constants/brandings";

const NameField = ({
  text,
  setText,
  operationPermissions,
  handleBusinessUnitForPayload,
}) => {
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <ContentHeader
        firstHeading="API Keys"
        secondHeading=" Enhance security and improve usability by generating your unique API key"
        buttonPermissions={[operationPermissions?.createAPIKey]}
        icon={<PowerOutlinedIcon    sx={{color:colorBrandObject.sideBarSelectedOptionBackground}} />}
        buttonText="Generate API Key"
        buttonType="primary"
        buttonSize="md"
        buttonVariant="contained"
        buttonOnclick={handleOpen}
      />
      <CreateApiKey
        open={open}
        onClose={handleClose}
        text={text}
        setText={setText}
        handleBusinessUnitForPayload={handleBusinessUnitForPayload}
      />
    </>
  );
};

export default NameField;
